var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2939,
    cy: 12,
    r: 12,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9267 17.6331H15.556V13.9203C15.556 13.035 15.5402 11.8953 14.323 11.8953C13.0883 11.8953 12.8993 12.8599 12.8993 13.8559V17.6328H10.5286V9.99793H12.8045V11.0413H12.8364C13.0641 10.6519 13.3933 10.3315 13.7887 10.1143C14.1841 9.89714 14.631 9.79129 15.0819 9.80802C17.4847 9.80802 17.9277 11.3885 17.9277 13.4447L17.9267 17.6331ZM7.8537 8.95429C7.5816 8.95434 7.31559 8.8737 7.08932 8.72257C6.86306 8.57143 6.6867 8.35659 6.58253 8.10522C6.47835 7.85385 6.45105 7.57722 6.50409 7.31034C6.55712 7.04345 6.68811 6.79828 6.88048 6.60584C7.07285 6.4134 7.31796 6.28232 7.58482 6.22919C7.85168 6.17606 8.12829 6.20325 8.3797 6.30734C8.6311 6.41142 8.84599 6.58772 8.9972 6.81394C9.14841 7.04016 9.22915 7.30615 9.2292 7.57825C9.22923 7.75892 9.19367 7.93783 9.12457 8.10476C9.05546 8.2717 8.95416 8.42338 8.82643 8.55116C8.6987 8.67893 8.54705 8.7803 8.38015 8.84947C8.21325 8.91864 8.03436 8.95426 7.8537 8.95429ZM9.03904 17.6331H6.66588V9.99793H9.03904V17.6331ZM19.1086 4.00109H5.47461C5.16515 3.9976 4.86696 4.11711 4.64557 4.33336C4.42419 4.54961 4.29772 4.84492 4.29395 5.15438V18.8454C4.29759 19.155 4.42398 19.4505 4.64536 19.667C4.86674 19.8835 5.165 20.0032 5.47461 19.9999H19.1086C19.4188 20.0038 19.7179 19.8844 19.9402 19.6679C20.1624 19.4515 20.2897 19.1556 20.2939 18.8454V5.15339C20.2895 4.84331 20.1622 4.54768 19.9399 4.33143C19.7177 4.11518 19.4187 3.99601 19.1086 4.0001",
    fill: "#4169E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.b5b2c64015db3b16d47f4fadc78e3f18.svg";
export { ForwardRef as ReactComponent };